import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-reject-dialog',
  templateUrl: './confirm-reject-dialog.component.html',
  styleUrls: ['./confirm-reject-dialog.component.scss']
})
export class ConfirmRejectDialogComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmRejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
